import { render, staticRenderFns } from "./verificaCopertura.vue?vue&type=template&id=1adad8a2&"
import script from "./verificaCopertura.vue?vue&type=script&lang=js&"
export * from "./verificaCopertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports